import type { TestStepProps } from 'src/suitability/engine/types';
import { BLOCK3_QUESTIONS, type ConsilioAnswers } from './answers';
import { ScoredBlock } from './scored-block';

export const StepBlock3 = (props: TestStepProps<ConsilioAnswers>) => (
  <ScoredBlock {...props} stepKey="block3" questions={BLOCK3_QUESTIONS} />
);
